import { useCallback, useEffect, useState } from "react";
import { ModalMostrarCalendario } from "./ModalMostrarCalendario";
import { ListaEventoTemporal } from "../Calendario/ListaEventoTemporal";
import { useDispatch, useSelector } from "react-redux";
import { estadosEvento, hotelesOpciones, tiposDeeventosSelect } from "../../../hook/Arreglos";
import { obtenerAdministradores } from "../../../store/admin/thunkAdmins";
import Select from "react-select";
import { obtenerListaEmpresas } from "../../../store/Empresa/thunkEmpresa";
import { traerTodoslosClientesSegunlaempresa } from "../../../store/clientes/thunkClientes";
import { formatEventDateOnly, parseEventDateTime } from "../../../store/Eventos/eventDateUtils";
import { UnificarModales } from "../Modales/UnificarModales";
import Swal from "sweetalert2";
import { crearEvento } from "../../../store/Eventos/thunkEventos";
import { useNavigate } from "react-router-dom";
import { setLimpiarTemporales } from "../../../store/Eventos/eventoSlice";

export const CrearEvento = () => {
    const navigate = useNavigate();
    // Redux hooks para manejar el estado global y despachar acciones.
    // `useSelector` se utiliza para seleccionar datos específicos del estado global.
    // `useDispatch` se utiliza para despachar acciones de Redux.
    const { eventosSeleccionados } = useSelector((state) => state.evento); // Eventos seleccionados del estado global.
    const { id_admin } = useSelector((state) => state.auth); // ID del administrador autenticado.
    const dispatch = useDispatch(); // Hook para despachar acciones a Redux.

    // Estado local para manejar la apertura y cierre del modal.
    const [openModal, setOpenModal] = useState(false); // Controla si el modal está abierto o cerrado.

    // Estado local para almacenar los datos del formulario.
    // Inicializamos con valores predeterminados.
    const [forms, setForms] = useState({
        selectedHotels: [], // Lista de hoteles seleccionados (id y nombre).
        selectedExecutives: [], // Lista de ejecutivos seleccionados (nombres e ids).
        tipodeeventos: "", // Tipo de evento seleccionado.
        selectedSalones: [], // Lista de salones seleccionados (id y nombre).
        estadoEvento: "", // Estado del evento actual.
        nombreEvento: "", // Nombre del evento.
        ingresoMonto: "", // Monto de ingreso asociado al evento.
        montajeEvento: "", // Detalles del montaje del evento.
        cantidadPersonas:0 , // Cantidad de personas esperadas (por defecto "--").
        notasEvento: "--", // Notas adicionales del evento (por defecto "--").
        empresaSeleccionada: "", // Empresa seleccionada en el formulario.
        clienteSeleccionado: "", // Cliente seleccionado en el formulario.
        datosCliente: [], // Detalles del cliente seleccionado.
        errors: {}, // Inicializar para manejar los errores
    });

    // Estado local para manejar el color asociado al estado del evento.
    const [colorEstado, setColorEstado] = useState(""); // Se actualiza en función del estado del evento seleccionado.

    // Estado local para almacenar las opciones disponibles de administradores.
    const [administradoresOptions, setAdministradoresOptions] = useState([]); // Lista de opciones de administradores.

    // Estado local para almacenar las opciones disponibles de empresas.
    const [empresasOptions, setEmpresasOptions] = useState([]); // Lista de opciones de empresas.

    // Estado local para manejar las opciones y datos de los clientes.
    const [clienteOptions, setClienteOptions] = useState([]); // Opciones del cliente para el selector.
    const [todosLosclientes, setTodosLosclientes] = useState([]); // Lista completa de clientes disponibles.

    // Función para abrir el modal.
    // Se utiliza para activar el estado `openModal`.
    const handleOpen = () => setOpenModal(true);

    // Función para cerrar el modal.
    // Cambia el estado `openModal` a falso.
    const handleClose = () => setOpenModal(false);

    /**
     * Obtiene el nombre del hotel dado su ID.
     * @param {string|number} idHotel - ID del hotel.
     * @returns {string} Nombre del hotel o "No encontrado" si no se encuentra.
     */
    const obtenerNombreHotel = (idHotel) => hotelesOpciones.find((opcion) => opcion.value === idHotel?.toString())?.label || "No encontrado";
    /**
     * Actualiza la lista de hoteles seleccionados en el estado del formulario
     * a partir de los eventos seleccionados.
     * @param {Array} eventos - Lista de eventos seleccionados.
     */
    const updateSelectedHotels = (eventos) => {
        setForms((prevForms) => {
            // Crear un conjunto con los IDs de hoteles asociados a los eventos seleccionados.
            const selectedHotelIds = new Set(eventos.map((evento) => evento.hotelid));

            // Filtrar los hoteles actualmente seleccionados que todavía están en los eventos seleccionados.
            const filteredHotels = prevForms.selectedHotels.filter((hotel) => selectedHotelIds.has(hotel.idHotel));

            // Mapear los eventos para obtener nuevos hoteles, asegurándose de evitar duplicados.
            const newHotels = Array.from(selectedHotelIds).map((idHotel) => ({
                idHotel, // ID único del hotel.
                nombreHotel: obtenerNombreHotel(idHotel), // Función para obtener el nombre del hotel.
            }));

            // Combinar los hoteles filtrados y los nuevos, eliminando duplicados.
            const updatedHotels = [...filteredHotels, ...newHotels.filter((newHotel) => !filteredHotels.some((filteredHotel) => filteredHotel.idHotel === newHotel.idHotel))];

            // Actualizar el estado con la lista de hoteles únicos.
            return {
                ...prevForms, // Mantener otros valores actuales del formulario.
                selectedHotels: updatedHotels, // Nueva lista de hoteles únicos seleccionados.
            };
        });
    };

    /**
     * Actualiza la lista de salones seleccionados en el estado del formulario
     * a partir de los eventos seleccionados.
     * @param {Array} eventos - Lista de eventos seleccionados.
     */
    const updateSelectedSalones = (eventos) => {
        setForms((prevForms) => {
            // Crear un conjunto con los IDs de salones asociados a los eventos seleccionados.
            const selectedSalonIds = new Set(eventos.map((evento) => evento.salonid));

            // Filtrar los salones actualmente seleccionados que todavía están en los eventos seleccionados.
            const filteredSalones = prevForms.selectedSalones.filter((salon) => selectedSalonIds.has(salon.idSalones));

            // Mapear los eventos para obtener nuevos salones y eliminar duplicados existentes.
            const newSalones = eventos
                .map(({ salonid, nombreSalon }) => ({
                    idSalones: salonid, // ID único del salón.
                    nombreSalon, // Nombre del salón directamente del evento.
                }))
                .filter((salon) => !filteredSalones.some((s) => s.idSalones === salon.idSalones)); // Evitar duplicados.

            // Combinar los salones filtrados y los nuevos, y actualizar el estado.
            return {
                ...prevForms, // Mantener otros valores actuales del formulario.
                selectedSalones: [...filteredSalones, ...newSalones], // Nueva lista de salones seleccionados.
            };
        });
    };

    /**
     * Configura las opciones de administradores y selecciona un administrador predeterminado si está disponible.
     */
    const configurarAdministradores = useCallback(async () => {
        /**
         * Convierte una lista de objetos en opciones para un selector.
         * @param {Array} data - Datos originales.
         * @param {string} valueKey - Clave que define el valor único en las opciones.
         * @param {string} labelKey - Clave que define la etiqueta mostrada en las opciones.
         * @returns {Array} Opciones mapeadas.
         */
        const mapToOptions = (data, valueKey, labelKey) =>
            data.map((item) => ({
                value: item[valueKey],
                label: item[labelKey],
            }));

        try {
            // Llama a la API para obtener administradores.
            const response = await dispatch(obtenerAdministradores());
            if (response && Array.isArray(response)) {
                // Mapea los datos a un formato de opciones para un selector.
                const adminOptions = mapToOptions(response, "id_admin", "name_admin");
                setAdministradoresOptions(adminOptions); // Actualiza el estado con las opciones de administradores.

                // Seleccionar automáticamente el administrador predeterminado si está disponible.
                const defaultAdmin = adminOptions.find((option) => option.value === id_admin);
                if (defaultAdmin) {
                    setForms((prevForms) => ({
                        ...prevForms, // Mantener los valores actuales.
                        selectedExecutives: [defaultAdmin], // Configurar el administrador predeterminado.
                    }));
                }
            }
        } catch (error) {
            console.error(`Error al obtener administradores: ${error.message}`); // Loguea errores específicos.
        }
    }, [dispatch, id_admin]);

    /**
     * Configura las opciones de empresas.
     */
    const configurarEmpresas = useCallback(async () => {
        /**
         * Convierte una lista de objetos en opciones para un selector.
         * @param {Array} data - Datos originales.
         * @param {string} valueKey - Clave que define el valor único en las opciones.
         * @param {string} labelKey - Clave que define la etiqueta mostrada en las opciones.
         * @returns {Array} Opciones mapeadas.
         */
        const mapToOptions = (data, valueKey, labelKey) =>
            data.map((item) => ({
                value: item[valueKey],
                label: item[labelKey],
            }));

        try {
            // Llama a la API para obtener empresas.
            const response = await dispatch(obtenerListaEmpresas());
            if (response && Array.isArray(response)) {
                // Mapea los datos a un formato de opciones para un selector.
                const empresaOptions = mapToOptions(response, "id_empresa", "nombre_empresa");
                setEmpresasOptions(empresaOptions); // Actualiza el estado con las opciones de empresas.
            }
        } catch (error) {
            console.error(`Error al obtener empresas: ${error.message}`); // Loguea errores específicos.
        }
    }, [dispatch]);

    // Ejecuta `ejecutarFunciones` al montar el componente.
    useEffect(() => {
        configurarAdministradores();
        configurarEmpresas();
    }, [configurarAdministradores, configurarEmpresas]);

    // Efecto para actualizar los hoteles y salones seleccionados cuando cambian los eventos seleccionados.
    useEffect(() => {
        updateSelectedHotels(eventosSeleccionados); // Actualiza los hoteles basados en los eventos seleccionados.
        updateSelectedSalones(eventosSeleccionados); // Actualiza los salones basados en los eventos seleccionados.
    }, [eventosSeleccionados]);

    /**
     * Maneja los cambios en la selección de un campo del formulario.
     * @param {any} value - Valor ingresado o seleccionado en el campo.
     * @param {string} field - Nombre del campo en el formulario que se está actualizando.
     */
    const handleChange = (value, field) => {
        // Actualiza dinámicamente el estado del formulario con el valor proporcionado.
        setForms((prevForms) => {
            const isError = value === "" || (Array.isArray(value) && value.length === 0); // Verifica si el campo está vacío

            return {
                ...prevForms,
                [field]: value, // Actualiza el valor del campo
                errors: {
                    ...prevForms.errors,
                    [field]: isError, // Marca error si está vacío
                },
            };
        });

        // Validación específica para el campo "estadoEvento".
        if (field === "estadoEvento") {
            // Busca en la lista de estados el estado seleccionado basado en su ID.
            const estadoSeleccionado = estadosEvento.find(
                (estado) => estado.id_estado === Number(value), // Conversión explícita a número para evitar errores de tipo.
            );

            if (estadoSeleccionado) {
                // Si se encuentra el estado, actualiza el color asociado al estado seleccionado.
                setColorEstado(estadoSeleccionado.color_estado);
            } else {
                // Si no se encuentra el estado, muestra un mensaje en la consola y limpia el color.
                console.log("Estado no encontrado.");
                setColorEstado(""); // Limpia el color del estado en caso de error o selección inválida.
            }
        }
    };

    // Función para borrar los datos del formulario relacionados con la empresa y el cliente.
    const borrarDatos = () => {
        // Actualizamos el estado del formulario para reiniciar los campos específicos.
        setForms((prevForms) => ({
            ...prevForms, // Mantenemos los valores actuales del formulario.
            empresaSeleccionada: "", // Reiniciamos el campo de empresa seleccionada.
            clienteSeleccionado: "", // Reiniciamos el cliente seleccionado.
            datosCliente: "", // Borramos los datos del cliente.
        }));

        // Limpiamos las opciones disponibles de clientes en el selector.
        setClienteOptions([]);
        // Limpiamos la lista de todos los clientes.
        setTodosLosclientes([]);

        configurarEmpresas(); // Volvemos a cargar las opciones de empresas.
    };

    // Función para ejecutar una lógica adicional cuando se selecciona una empresa.
    const ejecutarFuncionAdicional = async (selected) => {
        try {
            // Reiniciamos los campos del cliente en el formulario.
            setForms((prevForms) => ({
                ...prevForms, // Mantenemos los valores actuales del formulario.
                clienteSeleccionado: "", // Reiniciamos el cliente seleccionado.
                datosCliente: "", // Borramos los datos del cliente.
            }));

            // Limpiamos las opciones del cliente y la lista general antes de cargar los nuevos datos.
            setClienteOptions([]);
            setTodosLosclientes([]);

            // Despachamos una acción para obtener los clientes de la empresa seleccionada.
            const leadData = await dispatch(
                traerTodoslosClientesSegunlaempresa(selected?.value), // Pasamos el valor de la empresa seleccionada.
            );

            // Mapeamos los datos obtenidos para formar las opciones del selector.
            const options = leadData.map((cliente) => ({
                value: cliente.id_cliente, // ID del cliente como valor.
                label: cliente.nombre_cliente, // Nombre del cliente como etiqueta.
            }));

            // Actualizamos las opciones disponibles en el selector de clientes.
            setClienteOptions(options);
            // Almacenamos todos los datos de los clientes obtenidos.
            setTodosLosclientes(leadData);
        } catch (error) {
            // En caso de error, mostramos un mensaje en la consola.
            console.error("Error al cargar los clientes:", error);

            // Limpiamos las opciones y la lista de clientes para garantizar un estado consistente.
            setClienteOptions([]);
            setTodosLosclientes([]);
        }
    };

    // Función para manejar la selección de un cliente en el selector.
    const seleccionarCliente = async (selected) => {
        if (selected) {
            // Logueamos el cliente seleccionado en la consola.

            // Filtramos la lista de todos los clientes para encontrar el cliente seleccionado.
            const clientesFiltrados = todosLosclientes.filter(
                (cliente) => cliente.id_cliente === selected?.value, // Comparamos con el ID seleccionado.
            );

            // Actualizamos el formulario con los datos del cliente seleccionado.
            setForms((prevForms) => ({
                ...prevForms, // Mantenemos los valores actuales del formulario.
                datosCliente: clientesFiltrados[0], // Asignamos los datos del cliente encontrado.
            }));
        } else {
            // Si no se seleccionó ningún cliente, mostramos un mensaje en la consola.
            console.log("No se seleccionó ningún cliente.");
        }
    };

    /**
     * Maneja el evento de envío del formulario.
     * @param {Event} e - Evento del formulario.
     */
    const validateForm = () => {
  
        const newErrors = {
            tipodeeventos: !forms.tipodeeventos,
            selectedExecutives: !forms.selectedExecutives || forms.selectedExecutives.length === 0,
            estadoEvento: !forms.estadoEvento,
            nombreEvento: !forms.nombreEvento,
            ingresoMonto: !forms.ingresoMonto,
            montajeEvento: !forms.montajeEvento,
            cantidadPersonas: !forms.cantidadPersonas,
        };

        setForms((prevForms) => ({
            ...prevForms,
            errors: newErrors,
        }));

        return !Object.values(newErrors).some((error) => error); // Retorna true si no hay errores
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!validateForm()) {
            // Mostrar alerta si los campos están vacíos
            await Swal.fire({
                icon: "error",
                title: "Campos incompletos",
                text: "Por favor, llena todos los campos para continuar.",
            });
            return;
        }

        if (forms.empresaSeleccionada.length === 0 || forms.clienteSeleccionado.length === 0) {
            // Mostrar alerta con confirmación si no se selecciona una empresa o cliente
            const result = await Swal.fire({
                icon: "warning",
                title: "Empresa o cliente no seleccionados",
                text: "Estás creando un evento sin empresa ni cliente. Si deseas continuar, haz clic en Aceptar. Si no, cancela esta operación y selecciona una empresa y cliente para continuar.",
                showCancelButton: true,
                confirmButtonText: "Aceptar",
                cancelButtonText: "Cancelar",
            });

            if (!result.isConfirmed) {
                // Si el usuario cancela, no se continúa
                return;
            }
        }

        if (!eventosSeleccionados || eventosSeleccionados.length === 0) {
            // Mostrar alerta con confirmación si no se selecciona una fecha
            await Swal.fire({
                icon: "warning",
                title: "Lo sentimos",
                text: "No existe una fecha seleccionada. Por favor, verifica que al menos tengas una fecha asignada para poder continuar.",
                showCancelButton: true,
                confirmButtonText: "Aceptar",
                cancelButtonText: "Cancelar",
            });
            return;
        }

        // Mostrar confirmación final antes de proceder
        const finalResult = await Swal.fire({
            title: "¿Estás seguro?",
            text: "¿Deseas crear el evento?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Sí, crear",
            cancelButtonText: "Cancelar",
        });

        if (finalResult.isConfirmed) {
            const result = await dispatch(crearEvento(forms, eventosSeleccionados)); // Despachar acción para crear el evento

            if (result === "ok") {
                // Mostrar alerta con un temporizador
                Swal.fire({
                    title: "¡Éxito!",
                    text: "El evento se creó correctamente.",
                    icon: "success",
                    showConfirmButton: true, // Mostrará el botón de confirmación
                }).then(() => {
                    // Configurar la zona horaria de Costa Rica
                    // Filtrar eventos con fecha válida y extraer fecha y hotelId
                    const eventosFiltrados = eventosSeleccionados
                        .filter((evento) => {
                            const fechaEvento = parseEventDateTime(evento.start);
                            return Boolean(fechaEvento);
                        })
                        .map((evento) => ({
                            fecha: formatEventDateOnly(evento.start), // Usa misma normalización local que persistencia.
                            hotelId: evento.hotelid, // Corregido a "hotelid" para consistencia con los datos
                        }))
                        .filter((evento) => evento.fecha);

                    // Verificar si hay eventos disponibles
                    if (eventosFiltrados.length === 0) {
                        console.log("No hay eventos disponibles.");
                        return;
                    }

                    // Encontrar la fecha más antigua y su hotelId
                    const eventoMasAntiguo = eventosFiltrados.reduce((antiguo, actual) => {
                        return new Date(actual.fecha) < new Date(antiguo.fecha) ? actual : antiguo;
                    }, eventosFiltrados[0]);

                    // Resultado final
                    const { fecha: fechaMasAntigua, hotelId } = eventoMasAntiguo;
                    


                    dispatch(setLimpiarTemporales());
                    navigate(`/calendario/ver?datalook=${fechaMasAntigua}&data2=${hotelId}`);
                });
            } else {
                // Mostrar alerta si hay un error al editar el evento
                // await Swal.fire({
                //     icon: "error",
                //     title: "Error al editar el evento",
                //     text: "Ocurrió un error al intentar editar el evento. Por favor, intenta de nuevo.",
                // });
            }
        }
    };

    return (
        <div>
            <h4>Formulario de creacion de evento</h4>
            {/* Botón para abrir el modal */}

            <div className="d-flex justify-content-between align-items-center mb-3">
                <button onClick={handleOpen} className="btn btn-dark">
                    Desplegar Calendario dinamico
                </button>
                <UnificarModales />
            </div>

            {/* Formulario para crear evento */}
            <form onSubmit={handleSubmit} autoComplete="off">
                <div className="row">
                    <div className="col-sm-6">
                        <div className="card">
                            <div className="card-header">
                                <h5>Informacion de evento</h5>
                            </div>
                            <div className="card-body">
                                <div className="mb-3">
                                    <label className="form-label">Hotel Seleccionado</label>
                                    <input type="text" value={forms.selectedHotels.map((hotel) => hotel.nombreHotel).join(", ")} className="form-control" id="nombre_evento" required disabled />
                                </div>
                                <div className="mb-3">
                                    <label className="form-label">Seleccione a los ejecutivos</label>
                                    <Select autoComplete="off" isMulti options={administradoresOptions} value={forms.selectedExecutives} onChange={(selected) => handleChange(selected, "selectedExecutives")} placeholder="Seleccione ejecutivos" className={forms.errors.selectedExecutives ? "error-border" : ""} />
                                </div>
                                <div className="mb-3">
                                    <label className="form-label">Tipo de evento</label>
                                    <select autoComplete="off" className={`form-control ${forms.errors.tipodeeventos ? "error-border" : ""}`} value={forms.tipodeeventos} onChange={(event) => handleChange(event.target.value, "tipodeeventos")}>
                                        {tiposDeeventosSelect.map((option) => (
                                            <option key={option.value} value={option.value}>
                                                {option.label}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-sm-6">
                        <div className="card">
                            <div className="card-header">
                                <h5>Informacion de evento</h5>
                            </div>
                            <div className="card-body">
                                <div className="mb-3">
                                    <label className="form-label">Escoger Salones para el evento</label>
                                    <input type="text" value={forms.selectedSalones.map((salon) => salon.nombreSalon).join(", ")} className="form-control" id="salones" required disabled />
                                </div>
                                <div className="mb-3">
                                    <label className="form-label">Estado del evento</label>
                                    <select autoComplete="off" id="estadoEvento" className={`form-control ${forms.errors.estadoEvento ? "error-border" : ""}`} value={forms.estadoEvento} onChange={(event) => handleChange(event.target.value, "estadoEvento")}>
                                        <option value="" disabled>
                                            Selecciona un estado
                                        </option>
                                        {estadosEvento.map((estado) => (
                                            <option key={estado.id_estado} value={estado.id_estado}>
                                                {estado.nombre_estado}
                                            </option>
                                        ))}
                                    </select>
                                    <br />
                                    {colorEstado && (
                                        <div role="alert" className="fade alert alert-primary show" style={{ backgroundColor: colorEstado, color: "#fff" }}>
                                            <div className="d-flex align-items-center">
                                                <i className="ti ti-info-circle h2 f-w-400 mb-0"></i>
                                                <div className="flex-grow-1 ms-3">Color segun el estado seleccionado</div>
                                            </div>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <ListaEventoTemporal type="crear" />

                <div className="row">
                    <div className="col-sm-6">
                        <div className="card">
                            <div className="card-header">
                                <h5>Informacion de evento</h5>
                                <p>Por favor, complete todos los campos antes de continuar. Esta información es esencial para procesar su solicitud y asegurarse de que podamos brindarle el mejor servicio posible. Gracias por su colaboración.</p>
                            </div>
                            <div className="card-body">
                                <div className="mb-3">
                                    <label className="form-label">Nombre de evento</label>
                                    <input autoComplete="off" type="text" value={forms.nombreEvento} onChange={(event) => handleChange(event.target.value, "nombreEvento")} className={`form-control ${forms.errors.nombreEvento ? "error-border" : ""}`} id="nombreEvento" />
                                </div>
                                <div className="mb-3">
                                    <label className="form-label">Ingresos $ del evento</label>
                                    <input autoComplete="off" type="number" value={forms.ingresoMonto} onChange={(event) => handleChange(event.target.value, "ingresoMonto")} className={`form-control ${forms.errors.ingresoMonto ? "error-border" : ""}`} id="ingresoMonto" />
                                </div>
                                <div className="mb-3">
                                    <label className="form-label">Cantidad personas</label>
                                    <input autoComplete="off" type="text" value={forms.cantidadPersonas} onChange={(event) => handleChange(event.target.value, "cantidadPersonas")} className={`form-control ${forms.errors.cantidadPersonas ? "error-border" : ""}`} id="cantidadPersonas" />
                                </div>
                                <div className="mb-3">
                                    <label className="form-label">Montaje del evento</label>
                                    <input autoComplete="off" type="text" value={forms.montajeEvento} onChange={(event) => handleChange(event.target.value, "montajeEvento")} className={`form-control ${forms.errors.montajeEvento ? "error-border" : ""}`} id="montajeEvento" />
                                </div>

                                <div className="mb-3">
                                    <label className="form-label">Notas del evento</label>
                                    <textarea autoComplete="off" id="textarea" rows="3" placeholder="Mis notas" value={forms.notasEvento} onChange={(event) => handleChange(event.target.value, "notasEvento")} className={`form-control ${forms.errors.notasEvento ? "error-border" : ""}`} />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-sm-6">
                        <div className="card">
                            <div className="card-header d-flex justify-content-between align-items-center">
                                <h5 className="mb-0">Asignar Empresa Y Cliente</h5>
                                <button
                                    className="btn btn-danger"
                                    onClick={(e) => {
                                        e.preventDefault(); // Previene el comportamiento predeterminado del formulario
                                        borrarDatos(); // Llama a tu función
                                    }}
                                >
                                    Deseleccionar empresa
                                </button>
                            </div>

                            <div className="card-body">
                                <div className="mb-3">
                                    <label className="form-label">Seleccione la empresa</label>
                                    <Select
                                        autoComplete="off"
                                        options={empresasOptions}
                                        value={forms.empresaSeleccionada}
                                        onChange={(selected) => {
                                            handleChange(selected, "empresaSeleccionada");
                                            ejecutarFuncionAdicional(selected);
                                        }}
                                        placeholder="Seleccione empresa"
                                    />
                                </div>
                                <div className="mb-3">
                                    <label className="form-label">Seleccione el cliente segun la empresa</label>
                                    <Select
                                        autoComplete="off"
                                        options={clienteOptions}
                                        value={forms.clienteSeleccionado}
                                        onChange={(selected) => {
                                            handleChange(selected, "clienteSeleccionado");
                                            seleccionarCliente(selected);
                                        }}
                                        placeholder="Seleccione cliente"
                                        isDisabled={!forms.empresaSeleccionada}
                                    />
                                </div>
                                <div className="mb-3">
                                    <label className="form-label">Nombre del Cliente</label>
                                    <input type="text" value={forms.datosCliente?.nombre_cliente || ""} className="form-control" id="nombre_evento" required disabled />
                                </div>
                                <div className="mb-3">
                                    <label className="form-label">Correo del Cliente</label>
                                    <input type="text" value={forms.datosCliente?.correo_cleinte || ""} className="form-control" id="nombre_evento" required disabled />
                                </div>
                                <div className="mb-3">
                                    <label className="form-label">Telefono del Cliente</label>
                                    <input type="text" value={forms.datosCliente?.telefono_cliente || ""} className="form-control" id="nombre_evento" required disabled />
                                </div>
                            </div>
                        </div>
                    </div>
                    <button type="submit" className="btn btn-dark">
                        Crear nuevo Evento
                    </button>
                </div>
            </form>
            {/* Componente del Modal */}
            <ModalMostrarCalendario open={openModal} handleClose={handleClose} />
        </div>
    );
};
